import React, { useState, useEffect, useMemo } from "react";
import {
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    List,
    ListItem,
    ListItemText,
    InputAdornment,
    CircularProgress, IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { defaultVariables } from "../../../../config";
import {currencySymbol} from "../../../../config/values";
import AppCardLoaderFields from "../../loaders/AppCardLoaderFields";
import {useTranslation} from "react-i18next";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import RayaField from "./RayaField";

const CountryCodeChooser = ({setCountry,classes}) => {
    const [open, setOpen] = useState(false);
    const [countries, setCountries] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const [selectedCountry, setSelectedCountry] = useState({
        name: "Turkey",
        phonecode: "+90",
        iso2: "TR",
    });

    useEffect(() => {
        if (open) {
            setLoading(true);
            axios
                .get(`${defaultVariables.url}/auth/countries`)
                .then((response) => {
                    setCountries(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Error fetching countries:", error);
                    setLoading(false);
                });
        }
    }, [open]);
    useEffect(() => {
        if(!!selectedCountry){
            setCountry(selectedCountry);
        }
    }, [selectedCountry]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredCountries = useMemo(
        () =>
            countries.filter((country) =>
                country.name.toLowerCase().includes(searchQuery.toLowerCase()) || country.phonecode.toLowerCase().includes(searchQuery.toLowerCase())
            ),
        [countries, searchQuery]
    );

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setOpen(false);
    };

    return (
        <div>
            <RayaField
                value={`${selectedCountry.phonecode}`}
                slotProps={{
                    input:{
                        startAdornment: (
                            <InputAdornment position="start">
                                <img
                                    src={`https://flagsapi.com/${selectedCountry.iso2}/flat/24.png`}
                                    alt="flag"
                                    style={{ width: 24, height: 24,cursor:"pointer",borderRadius:12 }}
                                    loading="lazy"
                                />
                            </InputAdornment>
                        ),
                    }
                }}
                onClick={() => setOpen(true)}
                fullWidth
                className="inner-cursor"
            />

            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>
                    {t('selectACountry')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        size="small"
                        className={classes.dialogClose}
                    >
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={{height:400}}>
                    <RayaField
                        placeholder={t('search')}
                        fullWidth
                        autoFocus
                        value={searchQuery}
                        onChange={handleSearch}
                        slotProps={{
                            input:{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }
                        }}
                        sx={{ mb: 2,mt: 2 }}
                    />

                    {loading ? (
                        <AppCardLoaderFields/>
                    ) : (
                        <List>
                            {filteredCountries.map((country) => (
                                <ListItem
                                    button
                                    key={country.iso2}
                                    onClick={() => handleCountrySelect(country)}
                                    style={{cursor:"pointer"}}
                                >
                                    <img
                                        src={`https://flagsapi.com/${country.iso2}/flat/24.png`}
                                        alt="flag"
                                        style={{ width: 24, height: 24, marginRight: 4 }}
                                        loading="lazy"
                                    />
                                    <ListItemText
                                        primary={`${country.name} (${country.phonecode})`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default withStyles(Styles)(CountryCodeChooser);
